import MainMenuBlock from '../mainMenuBlock/MainMenuBlock';
import GoogleDirectionsHelper from 'helpers/GoogleDirectionsHelper';
import HandleRoutes from '../../layers/MeliaHandleRoutes';
import Utils from 'helpers/Utils';
import {HOTEL_DETAILS} from "../../globals/widgetTypes";

export default MainMenuBlock.extend({
	template: require('./directionsBox.hbs'),
	componentClass: 'directions-box',
	events: {
		'click .melia-close-icon': 'onClickClose',
		'click .melia-swap-icon': 'swap'
	},
	travelMode: 'driving',
	originIsMainHotel: true,
	autocompleteResultPosition: null,
	mainHotelPosition: null,
	directionsPoints: {
		from: null,
		to: null
	},

	directionsStrings: {
		from: null,
		to: null
	},

	constructor(options) {
		MainMenuBlock.prototype.constructor.call(this, options);
	},
	createConfigSubcomponents() {
		this.components = {
			AutocompleteTo: {
				position: 'to',
				componentConstructorClass: 'Autocomplete',
				identifier: 'Autocomplete',
				resultsPanel: this.$el.find('.lmm-autocomplete-results'),
				properties: {
					jpPosition: 'to',
					providers: {
						GPlacesAutocomplete: {
							icons: ['transit_station', 'bus_station', 'train_station'],
							minLength: 3,
							maxResults: 5
						},
                        ListHotelsProvider: {
                            minLength: 1,
                            maxResults: 5
                        }
					}
				},
				errorPanel: this.$el.find('.directionsBox-no-results-container')

			},
			JPList: {
				position: 'jp-list-results',
				identifier: 'JPList',
				componentConstructorClass: 'JPList',
				parent: this
			},
			TransportModes: {
				position: 'transport-modes',
				componentConstructorClass: 'TransportModes',
				identifier: 'TransportModes',
				properties: {
					event: 'TRANSPORT_MODE_SELECTED',
					defaultMode: 'driving'
				}
			}
		};
		if (!this.blockHotelInput) {
			this.components.AutocompleteFrom = {
				position: 'from',
				componentConstructorClass: 'Autocomplete',
				identifier: 'Autocomplete',
				resultsPanel: this.$el.find('.lmm-autocomplete-results'),
				properties: {
					jpPosition: 'from',
					providers: {
						GPlacesAutocomplete: {
							icons: ['transit_station', 'bus_station', 'train_station'],
							minLength: 3,
							maxResults: 5
						},
                        ListHotelsProvider: {
                            minLength: 1,
                            maxResults: 5
                        }
					}
				},
				errorPanel: this.$el.find('.directionsBox-no-results-container')
			};
		}
	},

	initialize(options) {
		this.blockHotelInput = options.properties.blockHotelInput;
		this.templateConfig.blockHotelInput = this.blockHotelInput;
		if (this.blockHotelInput) {
			this.directionsPoints.from = new google.maps.LatLng({
				lat: this.widget.hotelsJson.mainHotel.position.lat,
				lng: this.widget.hotelsJson.mainHotel.position.lng
			});
			this.templateConfig.inputMainHotelName = this.widget.hotelsJson.mainHotel.name;
			this.directionsStrings.from = this.widget.hotelsJson.mainHotel.name;
		}
		MainMenuBlock.prototype.initialize.call(this, options);
		this._configHandleRoute();
		if (this.widget.isMobileVersion) {
			this.$el.addClass('directions-box-mobile-version');
		}
	},
	_configHandleRoute() {
        const meliaCeruleanColor = '#0075c0';
        const meliaDarkGreen = '#26735B';
        const meliaDarkGray = '#A3A3A3';
        this.handleRoutes = new HandleRoutes(this.widget, {
            drawLabel: {
                zoomControl: 15
            },
            routeStyles: {
                type: 'modesStyle',
                defaultStyle: {
                    DRIVING: {
                        strokeWeight: 5,
                        strokeColor: meliaCeruleanColor,
                        icons: false,
                        zIndex: 20
                    },
                    BICYCLING: {
                        strokeWeight: 5,
                        strokeColor: meliaCeruleanColor,
                        icons: false,
                        zIndex: 20
                    },
                    TRANSIT: {
                        strokeWeight: 5,
                        strokeColor: meliaDarkGreen,
                        icons: false,
                        zIndex: 20
                    }
                },
                basicStyle: {
                    strokeWeight: 2,
                    strokeColor: meliaDarkGray,
                    strokeOpacity: 0.8,
                    icons: false,
                    zIndex: 10
                },
                highlightStyle: {
                    strokeOpacity: 1,
                    strokeWeight: 5,
                    zIndex: 40
                },
                selectedStyle: {
                    strokeWeight: 5,
                    zIndex: 30
                }
            }
        });
	},
	addListeners() {
		this.listenTo(this.bus, 'RESET_AUTOCOMPLETE', autocompleteComponent => {
			this.directionsPoints[autocompleteComponent.properties.jpPosition] = null;
			this._hideJPList();
			this.handleRoutes.removeRoutes();
			this._removeOriginDestinationMarkers();
			this.autocompleteResultPosition = null;
		});

		this.listenTo(this.bus,'AUTOCOMPLETE_RESULT_SELECTED', (item, autocompleteComponent) =>
        {
            this.directionsStrings[autocompleteComponent.properties.jpPosition] = item.value;
            if (this.widget.typeWidget === HOTEL_DETAILS && this.widget.isMobileVersion) {
                this.widget.$el.find('.lmm-hotel-resume-mobile-panel').hide();
            }
            if (item.address) {
                item.coordinates = new google.maps.LatLng(item.coords.lat, item.coords.lon);
                this.directionsPoints[autocompleteComponent.properties.jpPosition] = item.coordinates;
                this.autocompleteResultPosition = item.coordinates;
                this.getDirections();
            } else {
                item.coordinates().done(coords => {
                    this.directionsPoints[autocompleteComponent.properties.jpPosition] = coords.location;
                    this.autocompleteResultPosition = coords.location;
                    this.getDirections();
                });
            }
        });

		this.listenTo(this.bus, 'TRANSPORT_MODE_SELECTED', item => {
			this.travelMode = item.transportTypeEvent;
			this.getDirections();
		});
	},

	fillOriginWithHotel(hotelData) {
		this.directionsStrings.from = hotelData.title;
        if (this.components.AutocompleteFrom) {
            this.components.AutocompleteFrom.fillAutocomplete(hotelData.title);
        }
		this.directionsPoints.from = new google.maps.LatLng({
			lat: parseFloat(hotelData.latitudeCoordinates),
			lng: parseFloat(hotelData.longitudeCoordinates)
		});
	},

	getDirections() {
		if (this.directionsPoints.from && this.directionsPoints.to) {
			let origin;
			let destination;

			if (this.originIsMainHotel) {
				origin = this.directionsPoints.from;
				destination = this.directionsPoints.to;
			} else {
				origin = this.directionsPoints.to;
				destination = this.directionsPoints.from;
			}

			GoogleDirectionsHelper.getJourney(
				{ value: origin },
				{ value: destination },
				{ travelMode: this.travelMode }
			).then(routeResults => {
				this._removeOriginDestinationMarkers();
				if (
					routeResults.routes.length &&
					!this.directionsPoints.from.equals(this.directionsPoints.to)
				) {
					this.handleRoutes.updateRoutes(routeResults.routes);
					if (!this.blockHotelInput) {
						this._createOriginDestinationMarkers(
							routeResults.request.origin,
							routeResults.request.destination
						);
					}
				} else {
					this.handleRoutes.removeRoutes();
					routeResults.routes = [];
				}
				this._showJPList();
				this.components.JPList.updateRoute(routeResults, this.handleRoutes);
			});
		}
	},

	onClickClose() {
        const closeDirectionsBox = false;
		this.bus.trigger('directions_btn_event', closeDirectionsBox);
	},

	close() {
		this._hideJPList();
		this.handleRoutes.removeRoutes();
		this.components.AutocompleteTo._resetAutocomplete();
		this.directionsPoints.to = null;
		if (!this.blockHotelInput) {
			this.components.AutocompleteFrom._resetAutocomplete();
			this.directionsPoints.from = null;
		}
		this.autocompleteResultPosition = null;
		this.stopListening();
	},

	open() {
		this.show();
		this.addListeners();
		this.components.JPList.setIsDetailsPanelOpened(false);
	},

	getOriginText() {
		return this.originIsMainHotel
			? this.directionsStrings.from
			: this.directionsStrings.to;
	},

	getDestinationText() {
		return this.originIsMainHotel
			? this.directionsStrings.to
			: this.directionsStrings.from;
	},

	_hideJPList() {
		this.$el.find('.directions-box-jp-list-results').hide();
	},

	_showJPList() {
		this.$el.find('.directions-box-jp-list-results').show();
	},

	swap() {
		const toDirection = this.$el.find('.to-direction');
		const fromDirection = this.$el.find('.from-direction');

		this.originIsMainHotel = !this.originIsMainHotel;
		if (this.originIsMainHotel) {
			fromDirection.after(toDirection);
		} else {
			fromDirection.before(toDirection);
		}
		if (this.$el.find('.lmm-search-text-input')[0].value) {
			this.getDirections();
		}

	},

	getOriginIsMainHotel() {
		return this.originIsMainHotel;
	},

	_removeOriginDestinationMarkers() {
		if (this.originMarker && this.destinationMarker) {
			this.originMarker.setMap(null);
			this.destinationMarker.setMap(null);
			this.originMarker = null;
			this.destinationMarker = null;
		}
	},

	_createOriginDestinationMarkers(originPosition, destinationPosition) {
		this.bus.trigger('DELETE_POINT_REFERENCE');
		this.originMarker = this.widget.addMarkerToLayer(
			'BaseMapLayer',
			{ position: originPosition.location },
			{
				url: Utils.getImgUrl(
					this.widget.config.directionsOriginDestinationIcons.origin,
					this.widget
				),
				size: new google.maps.Size(25, 25),
				scaledSize: new google.maps.Size(25, 25)
			}
		);
		this.destinationMarker = this.widget.addMarkerToLayer(
			'BaseMapLayer',
			{ position: destinationPosition.location },
			{
				url: Utils.getImgUrl(
					this.widget.config.directionsOriginDestinationIcons.destination,
					this.widget
				),
				size: new google.maps.Size(25, 25),
				scaledSize: new google.maps.Size(25, 25)
			}
		);
	}
});



// WEBPACK FOOTER //
// ./src/components/directionsBox/DirectionsBox.js